import React from "react";
import styled from "styled-components";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormGrid, FormikForm } from "../../../../../forms";
import { ActionButtons } from "../../../../../forms/ActionButtons";
import { inputs } from "../../../../../inputs/inputConfigs";
import { vendorProductDataComponentId } from "../VendorProductsContainer";

const Wrapper = styled.div``;

const fields = {
  groups: [
    {
      items: [
        {
          input: inputs.name,
          grid: { xs: 12 },
        },
        {
          input: { ...inputs.description, required: true },
          grid: { xs: 12 },
        },
      ],
    },
  ],
};

export const EditVendorProduct = ({
  vendorProduct,
  handleEditVendorProduct,
  closeModalDialog,
}) => {
  return (
    <FormikForm
      initialValues={{
        name: vendorProduct.name,
        description: vendorProduct.description,
      }}
      onSubmit={handleEditVendorProduct}
      validationSchema={BWModels.loadSchema("Product")}
    >
      {({ handleSubmit, ...formikProps }) => (
        <Wrapper>
          <FormGrid fields={fields} {...formikProps} />
          <ActionButtons
            onSend={handleSubmit}
            onCancel={closeModalDialog}
            sendButtonText="Save"
            listeners={[vendorProductDataComponentId]}
            isModal
          />
        </Wrapper>
      )}
    </FormikForm>
  );
};
